var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveLevel2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.612,
    height: 42.205,
    viewBox: "0 0 23.612 42.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2641",
    "data-name": "Group 2641",
    transform: "translate(-622.771 -39.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M176.895,39.665V13.06a2.328,2.328,0,0,0-1.164-2.017l-9.477-5.472a2.328,2.328,0,0,0-2.328,0l-9.477,5.472a2.329,2.329,0,0,0-1.164,2.017v26.6a2.329,2.329,0,0,0,1.164,2.017l9.477,5.472a2.328,2.328,0,0,0,2.328,0l9.477-5.472a2.328,2.328,0,0,0,1.164-2.017",
    transform: "translate(469.488 34.388)",
    fill: "#99b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M179.159,43.374V18.961a2.329,2.329,0,0,0-1.164-2.017l-7.58-4.376a2.33,2.33,0,0,0-2.328,0l-7.579,4.376a2.328,2.328,0,0,0-1.164,2.017V43.374a2.328,2.328,0,0,0,1.164,2.017l7.579,4.376a2.328,2.328,0,0,0,2.328,0l7.58-4.376a2.329,2.329,0,0,0,1.164-2.017",
    transform: "translate(465.327 29.743)",
    fill: "#e0effd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(0 1.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M181.453,45.731l-2.684,1.41.513-2.989-2.172-2.116,3-.435,1.342-2.72L182.8,41.6l3,.435-2.171,2.116.513,2.989Z",
    transform: "translate(453.124 10.297)",
    fill: "#99b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M181.453,81.474l-2.684,1.41.513-2.989L177.11,77.78l3-.435,1.342-2.72,1.342,2.72,3,.435L183.625,79.9l.513,2.989Z",
    transform: "translate(453.124 -13.251)",
    fill: "#99b1c7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLevel2);
export default __webpack_public_path__ + "static/media/activeLevel2.e06c3c405e51dcc08f1b34871d84e532.svg";
export { ForwardRef as ReactComponent };